'use strict';

angular.module('webAgro1App').factory('ColheitaAfericaoService', function($http) {
  return {
    list: function(filters = {}) {
      filters.tipo = 'colheita_afericao';
      const url = `${SERVER + API_VERSION}operacoes_campo/visitas`;
      return $http.get(url, { params: filters });
    },

    /* eslint-disable */
    summarized: function(filters) {
      const params = !filters ? {} : {
        page: filters.page || null,
        safra: (filters.safra || {}).id || null,
        maquina: (filters.maquina || {}).id || null,
        atividade: (filters.atividade || {}).id || null,
        gleba: (filters.gleba || {}).id || null,
        dia: filters.dia || null
      };
      const url = `${SERVER + API_VERSION}colheita_afericoes/summarized`;
      return $http.get(url, { params: params });
    }
  };
});
